module.exports = __webpack_public_path__ + "img/checked1.9209056a.png";